// JsFromRoutes CacheKey a8ebe63dd57a44dc3d11ca1716ace2b6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  toggle: /* #__PURE__ */ definePathHelper('post', '/likes/toggle'),
}
